import styles from './createTransactionRulePrompt.module.scss';
import Selectors from 'src/utils/selectors';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import { ButtonPrimary } from '@americanexpress/dls-react';
import { DLSSize } from 'src/types/dls-size.enum';
import React from 'react';

export interface CreateTransactionRuleBoxProps {
    handleOnClick: () => void;
}

export default function CreateTransactionRulePrompt({ handleOnClick }: CreateTransactionRuleBoxProps): JSX.Element {
    return (
        <div
            className={styles.createRuleTransactionContainer}
            data-cy={Selectors.Transactions.CREATE_TRANSACTION_RULE_PROMPT}
        >
            <Typography variant={TypographyVariants.BODY} component="p" className={styles.ruleDescription}>
                {LiteralsService.getLiteral('CreateTransactionRulePrompt.description')}
            </Typography>
            <ButtonPrimary
                onClick={handleOnClick}
                size={DLSSize.SMALL}
                className={styles.createRuleButton}
                data-cy={Selectors.Transactions.CREATE_RULE_BUTTON}
            >
                {LiteralsService.getLiteral('CreateTransactionRulePrompt.button')}
            </ButtonPrimary>
        </div>
    );
}
